import moment from 'moment'

// 是否是ios设备
export const isIos = navigator.userAgent.match(/iphone|ipad|ipod/ig) !== null

// 是否是Android设备
export const isAndroid = navigator.userAgent.match(/android|linux.*mobile/ig) !== null

// 创建device token
export function deviceToken () {
  let token = localStorage.getItem('xhh_device_token')
  if (token) {
    return token
  } else {
    let time = new Date().getTime()
    let random = ('0000000000000000' + Math.floor(Math.random() * 9999999999999999)).slice(-16)
    let platform = 'h5'
    if (/micromessenger/.test(navigator.userAgent.toLowerCase())) {
      platform = 'weixin'
    } else if (navigator.userAgent.toLowerCase().match(/QQ/i) === 'qq') {
      platform = 'qq'
    } else if (navigator.userAgent.toLowerCase().match(/WeiBo/i) === 'weibo') {
      platform = 'weibo'
    }
    localStorage.setItem('xhh_device_token', time + '_' + random + '_' + platform)
    return time + '_' + random + '_' + platform
  }
}

// 数据分组
export function ArrayGroup (array, subGroupLength) {
  let index = 0, id = 0
  let newArray = []
  while (index < array.length) {
    let arr = array.slice(index, index += subGroupLength)
    arr = arr.map(i => {
      return [i, id++]
    })
    newArray.push(arr)
  }
  return newArray
}

// 处理PV数
export function handlePV (value, lang = 'zh') {
  let w = lang === 'zh' ? '万' : 'w'
  if (value >= 5000000) {
    return `500${w}+`
  } else if (value >= 10000) {
    let n = value / 10000
    return Number(n.toFixed(1)) + w
  } else {
    return value
  }
}

// 处理PV数
export function handlePVEn (value) {
  if (value >= 5000000) {
    return '500w+'
  } else if (value >= 10000) {
    let n = value / 10000
    return Number(n.toFixed(1)) + 'w'
  } else {
    return value
  }
}

// 设置cookie
export function setCookie (name, value, days) {
  const d = new Date()
  d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000))
  const expires = 'expires=' + d.toUTCString()
  document.cookie = name + '=' + value + '; ' + expires
}

// 获取cookie
export function getCookie (name) {
  const cname = name + '='
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    const c = ca[i].trim()
    if (c.indexOf(cname) === 0) {
      return c.substring(cname.length, c.length)
    }
  }
  return ''
}

// 删除cookie
export function delCookie (name) {
  const exp = new Date()
  exp.setTime(exp.getTime() - 1)
  const cVal = getCookie(name)
  if (cVal != null) {
    document.cookie = name + '=' + cVal + ';expires=' + exp.toUTCString()
  }
}

// checkMobile
export function checkMobile () {
  return /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)
}

// 处理时间
export function handleTimeFormatDay (time) {
  if (!time) return ''
  if (String(time).length < 13) {
    time = time * 1000
  }
  let t1 = moment(new Date(time).getTime())
  let t2 = moment(new Date().getTime())
  let str = ''
  let minutes = t2.diff(t1, 'minutes')
  if (minutes < 1) {
    str = '刚刚'
  }
  if (minutes >= 1 && minutes < 60) {
    str = minutes + '分钟前'
  }
  if (minutes >= 60) {
    let hours = t2.diff(t1, 'hours')
    if (hours < 24) {
      str = hours + '小时前'
    } else {
      let day = t2.diff(t1, 'day')
      if (day < 7) {
        str = day + '天前'
      } else {
        str = moment(t1).format('YYYY-MM-DD')
      }
    }
  }
  return str
}

// 生成uuid
export function get_uuid () {
  function s4 () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }

  function guid () {
    return (s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4())
  }

  return guid()
}

// 比较版本号
export function versionSupport (version) {
  let currentVersion = getCookie('xhw_version') || '0.0.0'
  let currentVersionStart = parseFloat(currentVersion)
  let currentVersionEnd = currentVersion.replace(currentVersionStart + '.', '')
  let versionStart = parseFloat(version)
  let versionEnd = version.replace(versionStart + '.', '')
  // 当前版本号开头比传入版本号大，那么无需对比直接返回true
  if (currentVersionStart > versionStart) {
    return true
  } else {
    // 当前版本号开头等于传入版本号，则需要对比尾号
    if (currentVersionStart === versionStart) {
      return Number(currentVersionEnd) >= Number(versionEnd)
    } else {
      return false
    }
  }
}

// 排序
export function sortData (data, by, sort = true) {
  if (sort) {
    data = aTob(data, by)
  } else {
    data = bToa(data, by)
  }
}
// 倒序
function aTob (data, by) {
  data.sort((a, b) => {
    a = a[by]
    b = b[by]
    return a - b
  })
}
// 正序
function bToa (data, by) {
  data.sort((a, b) => {
    a = a[by]
    b = b[by]
    return b - a
  })
}

// 生成随机数
export function getRandomNumber (max, min) {
  return Math.floor(Math.random() * (max - min + 1)) + min
}































